
import { MetaInfo } from 'vue-meta'
import { Component, Vue, Watch } from '~/utility/pu-class-decorator'
import { httpHeadersCache } from '~/apps/search/helpers'
import { isSearchUrlRoute } from '~/apps/search/isSearchUrlComponent'
import { ensureArray } from '~/utility/array'
import CATEGORY_MAP from '../../json/catRoot.json'
import SCHEMA_ORGANIZATION from '../../json/schemaOrganization.json'

@Component<SearchPage>({
  head: function () {
    return this.head()
  },
  httpHeaders: (ctx) => httpHeadersCache(ctx),
  key: 'SearchPage',
  watchQuery: false,
  middleware: ['httpHeaders', 'addParamsNoIndexTag'],
  validate({ route }) {
    return isSearchUrlRoute(route)
  },
})
export default class SearchPage extends Vue {
  get lang() {
    return this.$route.params.lang || 'en-gb'
  }

  @Watch('categoryIds', { immediate: true })
  onCategoryChange() {
    this.$nextTick(() => {
      this.$convertCom.setValues({
        pageType: 'search',
        categoryId: this.category.categoryId,
        categoryName: this.category.rootSlug,
      })
      this.$gtm.push({
        pageCategories: this.categorySlugs.join(','),
      })
    })
  }

  get category() {
    if (this.categoryIds?.length === 1) {
      return {
        categoryId: this.categoryIds[0],
        rootSlug: CATEGORY_MAP[this.categoryIds[0]],
      }
    }
    return {
      categoryId: undefined,
      rootSlug: undefined,
    }
  }

  get categorySlugs() {
    return (
      this.categoryIds
        ?.map((catId: string) => CATEGORY_MAP[catId])
        .filter((slug) => slug) || []
    )
  }

  get categoryIds() {
    return ensureArray(this.$route.query.type) as string[]
  }

  get query() {
    return (ensureArray(this.$route.query.q)[0] as string) || undefined
  }

  get placename() {
    return (ensureArray(this.$route.query.placename)[0] as string) || undefined
  }

  get schemaOrganization() {
    return {
      type: 'application/ld+json',
      body: true,
      json: SCHEMA_ORGANIZATION,
    }
  }

  head(): MetaInfo {
    return {
      bodyAttrs: {
        'data-desktop-search': this.$isDesktop ? 'true' : '',
      },
      script: [this.schemaOrganization],
    }
  }
}
